var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSnapshotFail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.19313 15.002C11.7781 15.002 14.6844 12.0958 14.6844 8.51076C14.6844 4.92575 11.7781 2.01953 8.19313 2.01953C4.60813 2.01953 1.7019 4.92575 1.7019 8.51076C1.7019 12.0958 4.60813 15.002 8.19313 15.002Z",
    fill: "#B91313"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.19314 9.64899C8.45928 9.64899 8.67998 9.42828 8.67998 9.16214V5.91653C8.67998 5.65039 8.45928 5.42969 8.19314 5.42969C7.927 5.42969 7.7063 5.65039 7.7063 5.91653V9.16214C7.7063 9.42828 7.927 9.64899 8.19314 9.64899Z",
    fill: "#B91313"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.79026 10.8641C8.75781 10.7862 8.71237 10.7148 8.65395 10.6498C8.58903 10.5914 8.51763 10.546 8.43973 10.5135C8.28395 10.4486 8.10219 10.4486 7.9464 10.5135C7.86851 10.546 7.7971 10.5914 7.73219 10.6498C7.67377 10.7148 7.62833 10.7862 7.59588 10.8641C7.56342 10.9419 7.54395 11.0263 7.54395 11.1107C7.54395 11.1951 7.56342 11.2795 7.59588 11.3574C7.62833 11.4418 7.67377 11.5067 7.73219 11.5716C7.7971 11.63 7.86851 11.6755 7.9464 11.7079C8.0243 11.7404 8.10868 11.7598 8.19307 11.7598C8.27745 11.7598 8.36184 11.7404 8.43973 11.7079C8.51763 11.6755 8.58903 11.63 8.65395 11.5716C8.71237 11.5067 8.75781 11.4418 8.79026 11.3574C8.82272 11.2795 8.84219 11.1951 8.84219 11.1107C8.84219 11.0263 8.82272 10.9419 8.79026 10.8641Z",
    fill: "#B91313"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnapshotFail);
export default __webpack_public_path__ + "static/media/snapshot-fail.f63f7d362b3c71056d868aa4b45198ea.svg";
export { ForwardRef as ReactComponent };